import { parseOptionalInt } from "./parseOptionalInt";

/** Default rate — brisk enough to see a pipeline move, slow enough to read. */
export const DEFAULT_EVENTS_PER_SECOND = "50";

// The rate the form submits: an empty box takes the default so a generator
// never stalls, and a typed zero is refused rather than silently clamped
// to one by the engine (TTTL-229).
export function eventsPerSecondPayload(text: string): number {
  const rate = parseOptionalInt(text) ?? Number(DEFAULT_EVENTS_PER_SECOND);
  if (rate < 1) throw new Error("Events per second must be at least 1");
  return rate;
}
